export default "__VITE_ASSET__D$903tPA__"